import React from "react";
import Select from "react-select";
import ic_filter from "./../../../assets/ic_filter.svg";
import ic_360degree_view from "./../../../assets/ic_360degree_view.svg";
import select_arrow_down from "./../../../assets/select_arrow_down.svg";
import Checkbox from "../../../common/Checkbox/Checkbox";
import {useEffect,useRef } from "react";
import ColumnSectionDropdown from "./ColumnSelectionDropdown";
import MultiSelectAll from "../../../common/Multiselect/MultiSelectAll";

export default function SPMFilterSection(props)
{
    return (
        <>
            <div className="col-12 lpm-filter-section conv-pl40 conv-pr40">
                <div className="row conv-mt20">
                    <div className="col-3 lpm-dropdown">
                        {/* <Select
                            styles={{
                                // Fixes the overlapping problem of the component
                                menu: provided => ({ ...provided, zIndex: 3 })
                            }}
                            placeholder="Assign Facilitator"
                            options={props.facilitatorList}
                            onChange={props.onSelectFacilitator}
                            value={props.selectedFacilitator}
                            isClearable
                            className='react-select-container'
                            classNamePrefix="react-select"
                            theme={theme => ({
                                ...theme,
                                colors: {
                                ...theme.colors,
                                primary: '#76287C',
                                primary25: '#F4DFF4',
                                },
                            })}
                        ></Select> */}
                    </div>
                    <div className="col-1">
                        {/* <button 
                            type="button" 
                            className={`lpm-con-btn-filled conv-mr25 conv-pl25 conv-pr25 
                            ${props.numberOfServices !== 0 &&props.selectedFacilitator? "": "disable"}`}
                            onClick={(e) =>props.onAssignHandholder(e)}>
                           Assign 
                        </button> */}
                    </div>
                    <div className="col-6">
                        <button 
                          type="button" 
                          className="spm-con-btn-bordered-filter conv-float-right conv-ml25 conv-pr25 conv-pl25"
                          onClick={(e) =>props.onClearFilterSearch(e)}>
                          Clear
                      </button>
						<button 
                            className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                            onClick={props.onSearchClicked}>
							Search
						</button>
						<input
							type="text"
							className="conv-float-right form-control conv-h250rem search-input "
							placeholder="Search"
							onChange={props.onSearchInputChange}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									props.onSearchClicked();
								}
							}}
							//autoComplete={false}
							value={props.searchTerm}
							name="searchTerm"
						/>
                        <div className="btn-search-by conv-float-right con-cursor-pointer"
                            onClick={()=>{
                                props.toggleSearchByVisibility();
                            }}
                        >
                            <span className="span-text-search-by">
                                Search By
                            </span>
                            <img
                                alt=""
                                src={select_arrow_down}
                                height={"12px"}
                                width={"12px"}
                                className="conv-ml10"
                            />                            
                        </div>	
                        {
                            props.isSearchByDropdownOpen &&
                            <div className="spm-search-by" ref={props.SearchDropdownRef}>
                                <ColumnSectionDropdown
                                    isOpen={props.isSearchByDropdownOpen}
                                    toggleSelection={props.selectSearchBySelection}
                                    checkboxItemsList={props.SearchByDropdownList}								
                                />
                            </div>
					    }	
                        				
					</div>
                    <div className="col-2">
                        <a className="conv-float-right con-cursor-pointer"
                            href="/home/three-sixty-degree-view-new/"target="_blank">
                            <img
                                alt=""
                                src={ic_360degree_view}
                                height={"15px"}
                                width={"21px"}
                                className="conv-mr10"
                            />
                            <span className="link360-view-text">
                                360 Degree View
                            </span>
                        </a>
                    </div>
                </div>
                <div className="row conv-mt20 spled-container">
                    <div className="col-2 width-100 conv-max-width-15p">
                        <MultiSelectAll
                            toggleAll={props.toggleAllForPackageFilter}
                            toggleSelection={props.toggleSelectionForPackageFilter}
                            checkboxItemsList={props.packageNameListForFilter}
                            selectedOptions={props.selectedPackageNameListForFilter}
                            placeholderButtonLabel={"Select Package"}
                        />
                    </div>
                    <div className="col-2 width-100 conv-max-width-15p">
                        <MultiSelectAll
                            toggleAll={props.toggleAllForServiceStatusFilter}
                            toggleSelection={props.toggleSelectionForServiceStatusFilter}
                            checkboxItemsList={props.serviceStatusNameListForFilter}
                            selectedOptions={props.selectedServiceStatusListForFilter}
                            placeholderButtonLabel={"Select Status"}
                        />
                    </div>
                    
                    <div className="col-8 con-col-8">
                        <div className="row">
                            {
                                props.showFeedbackButton?
                                (
                                    <button className="notification con-btn-bordered-lg conv-font14 conv-pl15 conv-pr15 con-br0 conv-pt9 conv-pb9 conv-float-left  conv-mr15 conv-ml15" 
                                        onClick={()=>{props.onTabChanged("Customer Feedback")}}
                                        >
                                        Customer Feedback
                                        <div className="notification-dot">{props.unReadFeedbackCount}</div>
                                    </button>
                                )
                                :("")
                            }
                            <button 
                                type="button" 
                                style={{
                                    visibility: "hidden"
                                }}
                                className={`lpm-con-btn-filled conv-mr15 conv-pl25 conv-pr25 conv-ml15`}
                                onClick={props.handleAssignFacilitatorUploadClick}>
                                Reassign Facilitator 
                            </button>
                            <div className="lpm-checkbox-label conv-pr5 conv-mr15 conv-pl15 conv-align-self-center">
                                <Checkbox
                                    id={`Show-Only-Unassigned`}
                                    checked={props.showUnassignedServiceRequests}
                                    onChange={props.toggleUnassignedServiceRequests}
                                    label={"Show Only Unassigned"}																	
                                ></Checkbox>
                            </div>

                            <div className="col-2">
                            <div className={`lpm-checkbox-label conv-pr5 conv-mr15 conv-width-240p conv-align-self-center con-cursor-pointer
                                ${props.numberOfServices !== 0? "": "disable"}`}
                                onClick={props.toggleConfirmHandholderAssignmentModal}
                            >
                                <span className="label-link">
                                    No. of Selected Services: 
                                </span>
                                <span className="label-link">
                                    {props.numberOfServices||0}
                                </span>
                            </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

